import { makeStyles } from '@material-ui/core/styles';

const WHITE = '#FFFFFF';
const supplementGreen = '#3A9891';
const dimmedGreen = '#79D5CE';
const TEXT_COLOR = '#FFFFFF';
const FONT_WEIGHT_LITE = 300;
const FONT_WEIGHT_BOLD = 400;
const LEFT = '22%';
const RIGHT = '78%';
const PADDING = '20px';

export const useStyles = makeStyles({
    parent: {
        backgroundColor: supplementGreen,
        marginBottom: '30px',
    },

    upperWrapper: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        justifyContent: 'center',
        minHeight: '144px',
        justifyItems: 'center',

        '& > flos-icon': {
            paddingLeft: PADDING,
            '& svg': {
                stroke: '#ffffff',
            },
        },
    },

    textbox: {
        color: WHITE,
        flexBasis: RIGHT,
        flexGrow: 0,
        padding: PADDING,

        '& > .header': {
            fontSize: '20px',
            fontWeight: FONT_WEIGHT_BOLD,
            lineHeight: '24px',
            paddingRight: PADDING,
        },
        '& > .text': {
            fontSize: '16px',
            fontWeight: FONT_WEIGHT_LITE,
            lineHeight: '20px',
            paddingRight: PADDING,
        },
        '& > .details': {
            color: dimmedGreen,
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: FONT_WEIGHT_LITE,
            lineHeight: '20px',
            paddingRight: PADDING,
        },
        '& .arrow': {
            stroke: dimmedGreen,
        },
        '& .open': {
            transform: 'rotate(-180deg)',
            transition: 'transform 150ms ease',
        },
        '& .closed': {
            transition: 'transform 150ms ease',
        },
    },
    lowerWrapper: {
        alignItems: 'center',
        borderTop: `1px dashed ${WHITE}`,
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        justifyContent: 'center',
        paddingRight: PADDING,
        paddingLeft: PADDING,
        color: TEXT_COLOR,
        fontSize: '16px',
        '& > .leftBox': {
            flexBasis: LEFT,
            flexGrow: 0,
        },
        '& > .rightBox': {
            flexBasis: RIGHT,
            flexGrow: 0,
            // Styling of HTML inside RenderHtml (from Hippo)
            '& > div': {
                color: WHITE,
                paddingTop: PADDING,
                paddingBottom: PADDING,
                paddingRight: PADDING,
                '& h4': {
                    fontSize: '16px',
                    fontWeight: FONT_WEIGHT_BOLD,
                    lineHeight: '20px',
                    margin: '10px 0 0 0',
                },
                '& p': {
                    fontSize: '16px',
                    fontWeight: FONT_WEIGHT_LITE,
                    lineHeight: '20px',
                    margin: '0 0 15px 0',
                },
            },
        },
    },
});
